import { ReactNode, useContext, useEffect } from "react"
import { AppActionContext, KeyboardModifiers, MouseState } from "./AppState.ts"
import { useEventListener } from "./hooks/useEventListener.ts"
import { vec2 } from "./VectorMath.ts"

export function MouseHandler(props: {
  element: HTMLElement
  state: MouseState
}): ReactNode {
  const { element, state } = props
  const sendAppAction = useContext(AppActionContext)

  usePointerLock(state, element)

  useEventListener('pointerdown', element, (event) => {
    if (event.button === 0) {
      sendAppAction({ type: 'reportMouseDown' })
    }
  })

  useEventListener('pointerup', element, (event) => {
    event.preventDefault()
    if (event.button === 0) {
      sendAppAction({ type: 'reportMouseUp' })
    }
  })

  useEventListener('mousemove', element, event => {
    sendAppAction({
      type: 'reportMouseMove',
      ndc: ndcOfMouseEvent(event),
      keyboardModifiers: keyboardModifiersOfEvent(event),
      movement: new vec2(event.movementX, event.movementY)
    })
  })

  useEventListener('wheel', element, event => {
    event.preventDefault()

    sendAppAction({
      type: 'reportScrollGesture',
      deltaY: event.deltaY
    })
  })


  return undefined
}

function usePointerLock(state: MouseState, element: HTMLElement) {
  const mouseMode = state.mode
  useEffect(() => {
    switch (mouseMode.type) {
    case 'idle':
      if (document.pointerLockElement) {
        document.exitPointerLock()
      }
      return
    case 'pendingClick':
      return
    case 'navigate':
    case 'dragBone':
      element.requestPointerLock({
      unadjustedMovement: true
    })
      return () => {
        document.exitPointerLock()
      }
    }
  }, [element, mouseMode])
}

function ndcOfMouseEvent(event: MouseEvent): vec2 {
  const target = event.target as HTMLElement
  const x = event.offsetX
  const y = event.offsetY
  return new vec2(
    2 * x / target.clientWidth - 1,
    1 - 2 * y / target.clientHeight
  )
}

function keyboardModifiersOfEvent(event: MouseEvent): KeyboardModifiers {
  return {
    shift: event.shiftKey,
  }
}
